import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { moveSectionDown, moveSectionUp, removeSection, setSectionFormType, setSectionType } from '../../../../../Features/storefrontSlice';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import ArrowUp from '../../../../../Assets/StorefrontIcons/ArrowUp.svg';
import Delete from '../../../../../Assets/DeleteRed.svg';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function SingleBannerDesktop({ item }) {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.versionData.find(section => section.item.typeData === item.item.typeData);

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('SINGLE_BANNER_DESKTOP'));
    }

    function handleUpClick() {
        if(item.prev) {
            dispatch(moveSectionUp({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDownClick() {
        if(item.next) {
            dispatch(moveSectionDown({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDeleteClick() {
        dispatch(removeSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleUpClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDownClick} className='outline-none size-8 flex items-center justify-center'>
                        <img className='rotate-180' src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <img className='w-full h-auto' src={getCachedMediaUrl(item.item.imageLink)} alt={item.item.altText} />
        </div>
    );
}

export default SingleBannerDesktop;
